<!--
    描述：用户组管理页面
    时间：2020-04-22
    Created by ws
-->
<template>
    <div class="h100">
        <w-split v-model="splitValue">
            <div class="h100" slot="left">
                <userGroupTable @groupTableRowClick="groupTableRowClick"></userGroupTable>
            </div>
            <div class="h100" slot="right">
                <wSplitRight v-model="rightSplitValue">
                    <div class="h100" slot="left">
                        <virtualDeptStructure ref="virtualDept"
                                              @virtualDeptRowClick="virtualDeptRowClick"></virtualDeptStructure>
                    </div>
                    <div class="h100" slot="right">
                        <groupUsersTable ref="groupUsersTable"></groupUsersTable>
                    </div>
                </wSplitRight>
            </div>
        </w-split>
    </div>
</template>

<script>
    import wSplit from '@/components/split/split'
    import wSplitRight from '@/components/split/split'
    import groupUsersTable from './components/group_users_table'
    import userGroupTable from './components/user_group_table'
    import virtualDeptStructure from './components/virtual_dept_structure'

    export default {
        components: {
            wSplit, wSplitRight, groupUsersTable, userGroupTable, virtualDeptStructure
        },
        data() {
            return {
                splitValue: 0.3,
                rightSplitValue: 0.4
            }
        },
        methods: {
            //左侧用户组列表单击行事件
            groupTableRowClick(row) {
                this.$refs.virtualDept.getVirtualDeptStructure(row.id);
                this.$refs.groupUsersTable.getGroupUsers(row, 'groupsClick');
            },

            //中间虚拟组织架构单击行事件
            virtualDeptRowClick(row) {
                this.$refs.groupUsersTable.getGroupUsers(row, 'virtualDeptClick');
            }
        },
        // 进入缓存页面
        activated() {
            this.splitValue = 0.3
            this.rightSplitValue = 0.4
        }
    }
</script>
<style scoped lang="less"></style>
